import { render, staticRenderFns } from "./GmailAdminOauthSettings.vue?vue&type=template&id=544429fe&scoped=true"
import script from "./GmailAdminOauthSettings.vue?vue&type=script&lang=js"
export * from "./GmailAdminOauthSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544429fe",
  null
  
)

export default component.exports